import {Utilities} from "./utilities";
const utilities = new Utilities();

export class Popup{
    constructor(){
        this.openButtons = document.querySelectorAll('.open-popup');
        this.closeButtons = document.querySelectorAll('.close-popup');
        this.allPopups = document.querySelectorAll('.popup');
    }
    init(){
        this.clickButtonOpen();
        this.clickButtonClose();
        this.clickEmptyClose();
    }
    clickButtonOpen(){
        this.openButtons.forEach((openButton)=>{
            openButton.addEventListener('click', (e)=>{
                this.open(e);
            })
        })
    }
    clickButtonClose(){
        this.closeButtons.forEach((openButton)=>{
            openButton.addEventListener('click', (e)=>{
                this.close();
            })
        })
    }
    clickEmptyClose(){
        this.allPopups.forEach((popup)=>{
            popup.addEventListener('click', (e)=>{
                if(e.target.classList.contains('popup')){
                    this.close();
                }
            })
        })
    }
    open(e){
        const id = e.target.getAttribute('data-popup');
        const thisPopup = document.getElementById(id);
        utilities.fadeIn(thisPopup, 'flex');
        if(thisPopup.querySelector('.splide') && !thisPopup.querySelector('.splide__arrows')){
            const testimonials1 = new Splide( '#testimonials-culture', {
                type   : 'loop',
                drag:  false
            }).mount();
        }
    }
    close(){
        this.allPopups.forEach((popup)=>{
            utilities.fadeOut(popup);
        })
    }
}
